const fn = {
  classCommentButtonHide: 'card__comments__btn--hide',
  init: (querySelector) => {
    const commentTextareas = document.querySelectorAll(typeof querySelector !== 'undefined' ? querySelector : '.js-comment-textarea');
    const eventListeners = [
      'keydown',
      'change',
      'cut',
      'copy',
      'paste',
      'focus',
    ];

    if (!commentTextareas.length) {
      return;
    }

    [].forEach.call(commentTextareas, (commentTextarea) => {
      const commentArea = commentTextarea.parentNode;

      if (commentTextarea.value.length < 2) {
        fn.toggleButton(commentArea, 'hide');
      }

      eventListeners.forEach((eventListener) => {
        commentTextarea.addEventListener(eventListener, () => {
          setTimeout(() => {
            commentTextarea.style.cssText = 'height: auto; max-height: auto;';
            commentTextarea.style.cssText = `height: ${commentTextarea.scrollHeight}px; max-height: ${commentTextarea.scrollHeight};`;

            if (commentTextarea.value.length >= 2) {
              fn.toggleButton(commentArea, 'show');
            } else {
              fn.toggleButton(commentArea, 'hide');
            }

            app.msnry.inst.layout();
          }, 0);
        });
      });
    });
  },
  toggleButton: (commentArea, state) => {
    const commentButton = commentArea.querySelector('.js-comment-button');

    if (!commentButton) {
      return;
    }

    if (commentButton.classList.contains(fn.classCommentButtonHide) && state === 'show') {
      commentButton.classList.remove(fn.classCommentButtonHide);
    } else if (state === 'hide') {
      commentButton.classList.add(fn.classCommentButtonHide);
    }
  },
};

export default fn;
